export const tabs = [
  {
    id: 1,
    label: 'Waiting payments',
    intlKey: 'tabs.waiting_payments',
    path: '/waiting'
  }
  // {
  //   id: 2,
  //   label: 'Expired payments',
  //   intlKey: 'tabs.expired_payments',
  //   path: '/expired'
  // }
]

export const tableHeadersWaiting = [
  {
    id: 3,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 4,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 5,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 6,
    label: 'Registration Date',
    intlKey: 'table.registration_date'
  },
  {
    id: 7,
    label: 'Email',
    intlKey: 'table.email'
  },
  {
    id: 8,
    label: 'Award Unit',
    intlKey: 'table.award_unit'
  },
  {
    id: 9,
    label: 'Level',
    intlKey: 'table.level'
  },
  {
    id: 10,
    label: 'Paid by',
    intlKey: 'table.paid_by'
  }
]

export const tableHeadersExpired = [
  {
    id: 3,
    label: 'ID',
    intlKey: 'table.id'
  },
  {
    id: 4,
    label: 'First Name',
    intlKey: 'table.first_name'
  },
  {
    id: 5,
    label: 'Last Name',
    intlKey: 'table.last_name'
  },
  {
    id: 6,
    label: 'Registration Date',
    intlKey: 'table.registration_date'
  },
  {
    id: 7,
    label: 'Email',
    intlKey: 'table.email'
  },
  {
    id: 8,
    label: 'Award Unit',
    intlKey: 'table.award_unit'
  },
  {
    id: 9,
    label: 'Level',
    intlKey: 'table.level'
  },
  {
    id: 10,
    label: 'Paid by',
    intlKey: 'table.paid_by'
  },
  {
    id: 11,
    label: 'Payment link',
    intlKey: 'table.payment_link'
  }
]
